/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadByInstallationRequestPost } from '../../models/heat-load-by-installation-request-post';
import { HeatLoadByInstallationResponse } from '../../models/heat-load-by-installation-response';

export interface CalculationsControllerInstallation$Params {
      body: HeatLoadByInstallationRequestPost
}

export function calculationsControllerInstallation(http: HttpClient, rootUrl: string, params: CalculationsControllerInstallation$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByInstallationResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerInstallation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadByInstallationResponse>;
    })
  );
}

calculationsControllerInstallation.PATH = '/planning-projects/v1/calculations/heat-load/installation';
